import * as React from 'react';
import { useParams } from 'react-router-dom';

import '../index.scss';
import './index.scss';

import AppLayout from '../../layouts/app/AppLayout';
import HeaderRightUserInfo from '../../components/headerRightUserInfo';
import OffPlanPropertiesList from './list';
import AddEditOffPlan from './addEdit';



export default function OffPlanSection() {
    const pageName = "Off-Plan";
    const { page = 'list' } = useParams()

    const getSelectedContent = () => {
        const selectedItem = page;
        let contentSelected = <OffPlanPropertiesList />
        switch (selectedItem) {
            case 'list':
                contentSelected = <OffPlanPropertiesList />;
                break;
            case 'view':
                contentSelected = <AddEditOffPlan />;
                break;
            case 'add':
                contentSelected = <AddEditOffPlan />;
                break;
            case 'edit':
                contentSelected = <AddEditOffPlan />;
                break;
            default:
                contentSelected = <span>Not found</span>;
                break;
        }
        return contentSelected;
    }



    return (
        <>
            <AppLayout
                pageName={pageName}
            >
                <div className="main-content-wrapper news-main-wrapper f-wrp">
                    <div className='panel-main-header f-wrp'>
                        <h1>{'Off-Plan Properties'}</h1>
                        <HeaderRightUserInfo />
                    </div>
                    <div className="main-container-wrp">
                        {getSelectedContent()}
                    </div>
                </div>
            </AppLayout >
        </>
    );
}